import React from 'react';
import { AssignedChip } from '../lib/types';
import PetDetails from '../components/ChipDetails/PetDetails/PetDetails';

export interface AssignedChipViewProps {
  chip: AssignedChip;
  reload(): void;
  onEditClicked(): void;
}

export default function AssignedChipView({ chip, reload, onEditClicked }: AssignedChipViewProps) {
  const { pet } = chip;
  const contactInfo = chip.latestContactHistoryEntry?.contactInfo;

  return (
    <div>
      {pet && (
        <PetDetails
          chip={chip}
          pet={pet}
          canEdit={true}
          canEditPhoto={true}
          contactInfo={contactInfo}
          onEditClicked={onEditClicked}
          onPetEdited={() => {
            reload();
          }}
        />
      )}
    </div>
  );
}
